// react
import React from 'react'

// external libs
import { Grid } from '@material-ui/core'
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

// components
import Dialog from '../../../../../../control/dialog/dialog'
import PageAction from '../../pageAction'
import UploadDoc from '../../../../shareUI/uploadDoc/uploadDoc'
import SiteVisitDetail from '../../../../shareUI/siteVisitDetail/siteVisitDetail'

// hooks
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useProjectSiteVisit from './useProjectSiteVisit'

// utils
import useCheckPermission from '../../../../../../utilities/checkPermission'

// types
import type { GetProjectResultType } from '../../../../../../services/web/types/responseWebServiceTypes'
import UploadAdditionalDoc from '../../../../shareUI/uploadAdditionalDoc/UploadAdditionalDoc'

export type ProjectSiteVisitViewType = ProjectSiteVisitType & ReturnType<typeof useProjectSiteVisit>

const ReportedAnonconformanceView = (props: ProjectSiteVisitViewType) => {
    const {
        formRef,
        onRefDialog,
        configDialog,
        initialValues,
        projectData,
        initialUploadFile,
        isViewMode,
        checkUseUploadEdit,
        onDirtyChange,
        onSubmitForm,
        onClickBackToSearch,
    } = props
    const manageProjectStore = useManageProjectStore()
    const { documentTopic } = manageProjectStore
    const checkPermission = useCheckPermission()
    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData, checkPermission.isUserAdmin())

    const isUserResearcher = checkPermission.isUserResearcher()

    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{ ...initialValues, uploadFile: initialUploadFile }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {(props) => {
                formRef.current = props
                return (
                    <React.Fragment>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <SiteVisitDetail dataSource={projectData} disabled={isUserResearcher} />
                            </Grid>

                            <Grid item xs={12}>
                                <UploadDoc
                                    initialData={initialUploadFile}
                                    documentTitleList={documentTopic}
                                    latestDocument={projectData?.latestDocument}
                                    isViewMode={isViewMode && !canUpdateDocument}
                                    isUseUploadfileEdit={checkUseUploadEdit()}
                                />
                            </Grid>

                            <Grid item xs={12} >
                                <UploadAdditionalDoc isViewMode={isViewMode && !canUpdateDocument} />
                            </Grid>

                            {!isViewMode || canUpdateDocument ? (
                                <Grid item xs={12}>
                                    <PageAction
                                        onClickSaveDraft={() => {
                                            props.form.change('submitType', 'draft')
                                            props.handleSubmit()
                                        }}
                                        onClickSave={() => {
                                            props.form.change('submitType', 'save')
                                            props.handleSubmit()
                                        }}
                                        onClickClose={onClickBackToSearch}
                                    />
                                </Grid>
                            ) : null}
                        </Grid>
                        <FormSpy subscription={{ dirty: true }} onChange={onDirtyChange} />
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </React.Fragment>
                )
            }}
        </Form>
    )
}
export type ProjectSiteVisitType = {
    projectData?: GetProjectResultType
    onSaveComplete?: (status: number, isDraft: boolean) => void
}

const ProjectSiteVisit = (props: ProjectSiteVisitType) => {
    const projectSiteVisit = useProjectSiteVisit(props)
    return <ReportedAnonconformanceView {...props} {...projectSiteVisit} />
}

export default ProjectSiteVisit
